import { styled } from "@/styled-system/jsx";
import Link from "next/link";

export const StyledButton = styled("button", {
  base: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
    padding: "10px 20px",
    fontWeight: "bold",
    border: "1px solid var(--color-primary)",
    borderRadius: "var(--border-radius-medium)",
    outline: "none",
    cursor: "pointer",
    transition: "background-color 0.3s, transform 0.3s, box-shadow 0.3s, color 0.3s",
    _disabled: {
      backgroundColor: "var(--color-light-gray)",
      color: "var(--color-text-light)",
      border: "1px solid var(--color-light-gray)",
      cursor: "not-allowed",
    },
    "&:not(:disabled):active": {
      transform: "scale(0.98)",
      boxShadow: "0 2px 6px rgba(0, 0, 0, 0.2)",
    },
    "&:not(:disabled):focus": {
      outline: "3px solid var(--color-primary-accent)",
      boxShadow: "0 0 10px rgba(168, 218, 220, 0.5)",
    },
  },
  variants: {
    priority: {
      primary: {
        backgroundColor: "var(--color-primary)",
        color: "var(--color-button-text)",
        "&:not(:disabled):hover": {
          backgroundColor: "var(--color-background)",
          color: "var(--color-text)",
          transform: "scale(1.05)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        },
      },
      secondary: {
        backgroundColor: "var(--color-secondary)",
        color: "var(--color-text)",
        "&:not(:disabled):hover": {
          backgroundColor: "var(--color-secondary-accent)",
          color: "var(--color-button-text)",
          transform: "scale(1.05)",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
        },
      },
    },
  },
  defaultVariants: { priority: "primary" },
});

export const SpinnerWrapper = styled("span", {
  base: {
    display: "flex",
    alignItems: "center",
  },
});

export const StyledSpinner = styled("span", {
  base: {
    width: "14px",
    height: "14px",
    border: "3px solid var(--color-text)",
    borderBottomColor: "transparent",
    borderRadius: "var(--border-radius-round)",
    display: "inline-block",
    boxSizing: "border-box",
    animation: "rotation 1s linear infinite",
  },
});

export const StyledLink = styled(Link, {
  base: {
    textDecoration: "none",
  },
});
